import React, {Component} from 'react';
import {NavLink} from "react-router-dom";
import PropTypes from "prop-types";

class Sidebar extends Component {
  render() {
    const {user} = this.props.auth;
    return (
        <div className="sidebar">
          <div className="card no-padding">
            <div className="card-header">
              <h2>Menu</h2>
            </div>
            <div className="card-body">
              <ul>
                <li><NavLink to="/dashboard">Dashboard</NavLink></li>
                {user.role !== 'general' && (<li><NavLink to="/warehouses">Warehouses</NavLink></li>)}
                {user.role === 'company' && (<li><NavLink to="/users">Users</NavLink></li>)}
                <li><NavLink to="/account-information">Account information</NavLink></li>
                <li><NavLink to="/notifications">Notifications</NavLink></li>
              </ul>
            </div>
          </div>
        </div>
    );
  }
}

Sidebar.propTypes = {
  auth: PropTypes.object.isRequired
};

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Layout/Sidebar/Sidebar.jsx